import React from 'react';
import '../styles/SocialSidebar.css';

const SocialSidebar = () => {
  return (
    <div className="social-sidebar" aria-label="Contact and social quick actions">
      <a
        className="social-item whatsapp"
        href={process.env.REACT_APP_WHATSAPP ? `https://wa.me/91${process.env.REACT_APP_WHATSAPP}?text=${encodeURIComponent('Hi ARK Moving Images, I would like to discuss about ...')}` : '#'}
        target="_blank"
        rel="noreferrer noopener"
        aria-label="Chat on WhatsApp"
      >
        <span className="icon" aria-hidden="true">
          {/* WhatsApp SVG */}
          <svg viewBox="0 0 32 32" width="20" height="20" fill="currentColor">
            <path d="M19.11 17.07c-.29-.14-1.68-.83-1.94-.92-.26-.1-.45-.14-.64.14-.19.29-.74.92-.9 1.11-.17.19-.33.22-.61.07-.29-.14-1.21-.45-2.31-1.44-.85-.76-1.43-1.7-1.6-1.99-.17-.29-.02-.45.12-.59.12-.12.29-.33.43-.5.14-.17.19-.29.29-.48.1-.19.05-.36-.02-.5-.07-.14-.64-1.54-.88-2.11-.23-.55-.47-.48-.64-.48h-.55c-.19 0-.5.07-.76.36-.26.29-1 1-1 2.43s1.03 2.82 1.17 3.01c.14.19 2.03 3.1 4.92 4.35.69.3 1.22.48 1.64.62.69.22 1.31.19 1.81.12.55-.07 1.68-.69 1.92-1.36.24-.67.24-1.24.17-1.36-.07-.12-.26-.19-.55-.33z" />
            <path d="M26.7 5.3C23.9 2.49 20.13 1 16.17 1 8.39 1 2.04 7.35 2.04 15.13c0 2.66.7 5.25 2.03 7.54L2 31l8.5-2.23c2.23 1.22 4.75 1.86 7.33 1.86 7.78 0 14.13-6.35 14.13-14.13 0-3.77-1.47-7.32-4.27-10.13zM16.83 28.18c-2.35 0-4.66-.63-6.68-1.84l-.48-.28-5.05 1.32 1.35-4.92-.31-.5c-1.27-2.05-1.93-4.42-1.93-6.83 0-7.17 5.83-13 13-13 3.47 0 6.73 1.35 9.19 3.8 2.46 2.46 3.81 5.72 3.81 9.2 0 7.17-5.83 13-13 13z" />
          </svg>
        </span>
        <span className="label">WhatsApp</span>
      </a>

      <a
        className="social-item phone"
        href={process.env.REACT_APP_PHONE_NUMBER ? `tel:+91${process.env.REACT_APP_PHONE_NUMBER}` : '#'}
        aria-label="Call us"
      >
        <span className="icon" aria-hidden="true">
          {/* Phone SVG */}
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.11.37 2.3.57 3.58.57a1 1 0 011 1v3.5a1 1 0 01-1 1C10.85 22.82 1.18 13.15 1.78 3a1 1 0 011-1h3.5a1 1 0 011 1c0 1.28.2 2.47.57 3.58a1 1 0 01-.24 1.01l-2.2 2.2z"/>
          </svg>
        </span>
        <span className="label">Call</span>
      </a>

      <a
        className="social-item instagram"
        href={process.env.REACT_APP_INSTAGRAM || '#'}
        target="_blank"
        rel="noreferrer noopener"
        aria-label="Visit Instagram"
      >
        <span className="icon" aria-hidden="true">
          {/* Instagram SVG */}
          <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
            <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm0 2a3 3 0 00-3 3v10a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H7zm5 3a5 5 0 110 10 5 5 0 010-10zm0 2.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM18 6.5a1 1 0 110 2 1 1 0 010-2z"/>
          </svg>
        </span>
        <span className="label">Instagram</span>
      </a>
    </div>
  );
};

export default SocialSidebar;


